import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center justify-between" }

import { computed, PropType } from "vue";
import { FormKitFrameworkContext } from "@formkit/core";
import IconButton from "@/components/IconButton.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'NumberInput',
  props: {
  context: {
    type: Object as PropType<
      FormKitFrameworkContext & { max?: number; min?: number }
    >,
    required: true,
  },
},
  setup(__props) {

const props = __props;

const selectModel = computed({
  get() {
    return props.context._value;
  },
  set(value) {
    if (props.context.node) {
      props.context.node.input(value ?? 1);
    }
  },
});

function changeBy(by: number) {
  if (isNaN(parseInt(selectModel.value))) {
    selectModel.value = 0;
  }
  selectModel.value = (parseInt(selectModel.value) ?? 0) + by;
  if (selectModel.value < 1) selectModel.value = 1;
}

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(IconButton, {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (changeBy(-1))),
      icon: "minus"
    }),
    _createVNode(_component_FormKit, {
      type: "text",
      name: "amount",
      modelValue: selectModel.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectModel).value = $event)),
      max: props.context.max,
      min: props.context.min,
      classes: {
        outer: '$reset mb-0 mx-xs',
      }
    }, null, 8, ["modelValue", "max", "min"]),
    _createVNode(IconButton, {
      onClick: _cache[2] || (_cache[2] = ($event: any) => (changeBy(1))),
      icon: "plus"
    })
  ]))
}
}

})